import Content from '../../../content';

namespace('IO.Views.FirewallRules', function (exports) {
  'use strict';

  var validOctets,
    cleanSelect2ToIpField,
    shouldValidate,
    TemplateNameGenerator = IO.Views.Components.TemplateNameGenerator,
    IpField = IO.Views.Components.IpField,
    SimpleField = IO.Views.Components.SimpleField,
    New = Content.extend({
      dom: {
        ADDITIONAL_FIELDS_TOGGLE: '.additional-fields-toggle',
        ADDITIONAL_FIELDS_TOGGLE_LINK: '.additional-fields-toggle-link',
        IP_FIELDS: '.ip-multiple-value-property:not(.multiple-values)',
        IP_MULTIPLE_FIELDS: '.ip-multiple-value-property.multiple-values',
        SELECT2_FIELD: '.select2select',
        TEMPLATE_NAME_FROM: '#firewall_rule_name',
        TEMPLATE_NAME_TO: '#firewall_rule_template_name',
        SIMPLE_MULTIPLE_FIELDS: '.simple-multiple-value-attribute-container',
        VISIBLE_FORM: 'form:visible',
        UNSELECT_BUTTON: '.unselect-radio-buttons',
        APPEND_WITH_VALUE_OPTION: '.with-value',
        CREATE_CHAIN: '#firewall_rule_chain',
        CREATE_TABLE: '#firewall_rule_table',
        IMPACT_CANCEL: '#impact-form .io-form-action-cancel',
        IMPACT_FORM: '#impact-form',
      },

      events: function () {
        var events = {};

        events['click ' + this.dom.ADDITIONAL_FIELDS_TOGGLE_LINK] =
          '_toggleAdditionalFields';
        events['click ' + this.dom.UNSELECT_BUTTON] = '_unselectRadioButton';
        events['change ' + this.dom.CREATE_CHAIN] = '_setTableValue';
        events['click ' + this.dom.IMPACT_CANCEL] = '_impactCancel';
        return events;
      },

      afterRender: function (options) {
        if (options && options.contentEditable) {
          options.contentEditable.addValidation($.proxy(this._isValid, this));
        }
      },

      onDestroy: function () {
        this.templateName.destroy();
        this.templateName = null;
        this.ipMultipleFields.destroy();
        this.ipFields.destroy();
        this.simpleMultipleFields.destroy();

        this.$el.find(this.dom.UNSELECT_BUTTON).off();
      },

      render: function () {
        var $select = this.$(this.dom.SELECT2_FIELD),
          customOptions,
          invalidFields;

        if (!$select.closest('.hide').length) {
          if (!$select.hasClass('select2-offscreen')) {
            customOptions = {
              acceptNotFound: true,
              allowClear: true,
              placeholder: '',
            };

            $select
              .select2(window.select2Defaults(customOptions))
              .on('change', function (e) {
                var element = $(e.target),
                  ipType,
                  message,
                  validIp,
                  octetSize;

                cleanSelect2ToIpField(element);

                ipType = /^(-?[\d.]){1,}$/;
                if (
                  shouldValidate(e.target.name) === true &&
                  element.val().match(ipType)
                ) {
                  message = '';
                  validIp = /^(?:\d{1,3}\.){3}\d{1,3}$/;
                  octetSize = 4;

                  if (
                    !element.val().match(validIp) &&
                    element.val().split('.').length !== octetSize
                  ) {
                    message += 'Only 4 octets will be accepted.</br>';
                  }

                  if (validOctets(element.val()) === false) {
                    message +=
                      'Octets will be by accepted if they are between 0 and 255.';
                  }

                  if (message.length > 0) {
                    element.addClass('field_with_errors');
                    element
                      .closest('td')
                      .append('<small class="error">' + message + '</small>');
                  }
                }
              });

            $.each($select, function (_, select) {
              customOptions.acceptNotFound =
                $(select).data('acceptCustomValue') !== false;
              $(select).select2(window.select2Defaults(customOptions));
            });
          }
        }

        this.templateName = new TemplateNameGenerator({
          from: this.$(this.dom.TEMPLATE_NAME_FROM),
          to: this.$(this.dom.TEMPLATE_NAME_TO),
        });
        this.templateName.run();

        this.ipFields = new IpField({ el: this.$(this.dom.IP_FIELDS) });
        this.ipMultipleFields = new IpField({
          el: this.$(this.dom.IP_MULTIPLE_FIELDS),
          multiple: true,
        });

        this.simpleMultipleFields = new SimpleField({
          el: this.$(this.dom.SIMPLE_MULTIPLE_FIELDS),
          multiple: true,
          limited: {
            dport: 15,
            sport: 15,
          },
        });

        invalidFields = $(this.el).find('.error');

        if (invalidFields.length > 0) {
          $('html, body').animate(
            {
              scrollTop: this.$el.offset().top - 100,
            },
            500,
          );
        }
      },

      _setTableValue: function (e) {
        if (
          $(e.target).val() === 'PREROUTING' ||
          $(e.target).val() === 'POSTROUTING'
        ) {
          $(this.dom.CREATE_TABLE).val('nat').trigger('change');
        }
      },

      _unselectRadioButton: function (e) {
        this.$el
          .find(e.currentTarget)
          .closest('div')
          .find('span.checked')
          .removeClass('checked');

        this.$el
          .find(e.currentTarget)
          .closest('div')
          .find('input:checked')
          .prop('checked', false);

        this.$el
          .find(e.currentTarget)
          .closest('div')
          .find(this.dom.APPEND_WITH_VALUE_OPTION)
          .val('');
      },

      _toggleAdditionalFields: function (e) {
        var $additionalFields = $(e.currentTarget).parent();

        e.preventDefault();
        $additionalFields.toggleClass('open');
        $additionalFields
          .find(this.dom.ADDITIONAL_FIELDS_TOGGLE)
          .stop()
          .slideToggle(function () {
            $(this).css('overflow', 'visible');
          });
      },

      _isValid: function (e) {
        var valid =
            this.ipFields.isValid() &&
            this.ipMultipleFields.isValid() &&
            this.simpleMultipleFields.isValid(),
          $invalidFields;

        if (!valid) {
          $invalidFields = $(e.currentTarget).find('.error');

          $('html, body').animate(
            {
              scrollTop: $($invalidFields[0]).offset().top - 100,
            },
            500,
          );
        }

        return valid;
      },

      _impactCancel: function (e) {
        var form = $(this.dom.IMPACT_FORM);

        e.preventDefault();
        form.append('<input name="edit" type="hidden" value="1" />');
        form.submit();
      },
    });

  validOctets = function (value) {
    var octetsAreValid = true,
      octet;

    value.split('.').forEach(function (el) {
      octet = parseInt(el);

      if (octet < 0 || octet > 255) {
        octetsAreValid = false;
      }
    });
    return octetsAreValid;
  };

  cleanSelect2ToIpField = function (element) {
    element.closest('td').find('small.error').remove();
    element.removeClass('field_with_errors');
  };

  shouldValidate = function (element) {
    var validate = false,
      elements = ['destination', 'source', 'todest'];

    elements.forEach(function (el) {
      if (element.indexOf(el) >= 0) {
        validate = true;
      }
    });
    return validate;
  };

  exports.New = New;
});
